/** @module Specification/CareAndComposition/CareInstructionPerLanguageRenderer */
define([
    "dojo/_base/declare",
    "csi/heading/String",
    "./CareSymbolPerLanguageRendererMixin"
], function(declare,StringRen,CareSymbolPerLanguageRenderer) {

    return declare([StringRen,CareSymbolPerLanguageRenderer], {

    });
});